import React from "react";
import { graphql, Link as GatsbyLink } from "gatsby";
import {
  Heading,
  Container,
  Center,
  Text,
  Table,
  Tr,
  Td,
  Th,
  Tbody,
  Thead,
  Link,
  UnorderedList,
  ListItem,
  Box,
  OrderedList,
} from "@chakra-ui/react";
import Interweave from "interweave";

import Layout from "../components/Layout";

const transformHtml = (node, children) => {
  if (node.tagName === "H1") {
    return (
      <Heading id={node.id} fontFamily="Noto sans, Sans serif" color="gray">
        {children}
      </Heading>
    );
  }
  if (node.tagName === "H2") {
    return (
      <Heading
        id={node.id}
        size="md"
        fontFamily="Noto sans, Sans serif"
        color="gray"
      >
        {children}
      </Heading>
    );
  }
  if (node.tagName === "P") {
    return (
      <Text
        fontFamily="Noto sans, Sans serif"
        textAlign="justify"
        marginBottom="1em"
      >
        {children}
      </Text>
    );
  }

  if (node.tagName === "TABLE") {
    return (
      <Box borderWidth="1px" borderRadius="lg">
        <Table variant="striped">{children}</Table>
      </Box>
    );
  }
  if (node.tagName === "TR") {
    return <Tr>{children}</Tr>;
  }
  if (node.tagName === "TH") {
    return <Th>{children}</Th>;
  }
  if (node.tagName === "TD") {
    return <Td p="0.5rem">{children}</Td>;
  }
  if (node.tagName === "TBODY") {
    return <Tbody>{children}</Tbody>;
  }
  if (node.tagName === "THEAD") {
    return <Thead>{children}</Thead>;
  }
  if (node.tagName === "UL") {
    return (
      <Text fontFamily="Noto sans, Sans serif">
        <UnorderedList>{children}</UnorderedList>
      </Text>
    );
  }
  if (node.tagName === "OL") {
    return (
      <Text fontFamily="Noto sans, Sans serif">
        <OrderedList>{children}</OrderedList>
      </Text>
    );
  }
  if (node.tagName === "LI") {
    return <ListItem>{children}</ListItem>;
  }

  if (node.tagName === "A") {
    if (
      node.getAttribute("href").includes("http") ||
      node.getAttribute("href").includes("mailto") ||
      node.getAttribute("href").includes(".pdf")
    ) {
      return (
        <Link href={node.getAttribute("href")} isExternal>
          {children}
        </Link>
      );
    }

    return <GatsbyLink to={node.getAttribute("href")}>{children}</GatsbyLink>;
  }
};

const PageTemplate = ({ data }) => {
  const { markdownRemark } = data;
  const { frontmatter, html } = markdownRemark;

  const content = (
    <Center>
      <Container maxW="3xl" centerContent marginTop="100px">
        <Heading
          color="gray"
          fontFamily="Noto sans, Sans serif"
          marginBottom="1em"
        >
          {frontmatter.title}
        </Heading>
        <Interweave content={html} transform={transformHtml} />
      </Container>
    </Center>
  );
  return <Layout children={content} />;
};

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        slug
        title
      }
    }
  }
`;

export default PageTemplate;
